export default __webpack_public_path__ + "static/media/point.4c4b490e.svg";